module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/statue-3.ab783ca3.png";